/**
 * Returns a Map of key -> count for items in the array, using getKey to derive the key.
 * Used to detect duplicate keys (e.g. in user lists) so you can add extra data to those
 * fields (e.g. email, id) and make them distinguishable for the user.
 */
export const getCountsByKey = <T>(items: T[] | undefined, getKey: (item: T) => string): Map<string, number> => {
  const counts = new Map<string, number>();
  for (const item of items ?? []) {
    const key = getKey(item);
    counts.set(key, (counts.get(key) ?? 0) + 1);
  }
  return counts;
};
